export default __webpack_public_path__ + "7a8b4f130182d19a2d7c67d80c090397.svg";